import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoadingSpinner from '../ui/LoadingSpinner';
import AbEnvironment from '../auth/AbEnvironment';
import AppFetchForSO from './AppFetchForSO';
import AccountFetch from '../account/AccountFetch';

const abEnvironment = new AbEnvironment();

// Verify needs to show spinner, call the invitetoken API with the user parm
class SubscriptionOrderLoad extends Component {

  getAppFromCatalog(appId, appDomain) {

    let accountId = abEnvironment.getUserAttribute("a_id");

    return new Promise(function(resolve, reject) {
      AppFetchForSO.fetch(accountId, appId, appDomain).toPromise()
      .then(appf => {
        if (appf.appsearchforsopopulation.nodes[0]) {
          localStorage.setItem('soAppParm', JSON.stringify(appf.appsearchforsopopulation.nodes[0]));
        }
        resolve({success:1});

      })
      .catch(err => {
        resolve({success:0});
      });
    });
  }

  getCustomer(accountId) {
    return new Promise(function(resolve, reject) {
     AccountFetch.fetch(accountId).toPromise()
      .then(af => {
        if (af.accountTByAccountId) {

          let params = {
            accountId: af.accountTByAccountId.accountId,
            companyName: af.accountTByAccountId.companyName,
            contactLastName: af.accountTByAccountId.contactLastName, 
            contactFirstName: af.accountTByAccountId.contactFirstName, 
            contactEmail: af.accountTByAccountId.contactEmail
          };

          localStorage.setItem('soCustomerParms', JSON.stringify(params));
        }
        resolve({success:1});

      })
      .catch(err => {
        resolve({success:0});
      });
    });
  }



  render() {


    const params = new URLSearchParams(this.props.location.search);

    let customerId = params.get('customerId');
    let appId = params.get('appId');
    let appDomain = params.get('appDomain');

    const { isAuthenticated } = this.props.auth;

    if (isAuthenticated() && (!appDomain && !appId && !customerId)) { 
      return ( <Redirect to='/subscriptionorder' /> );
    } else {
      if (!customerId && !appId && !appDomain) {
        return ( <Redirect to='/subscriptionorder' /> );
      }

      Promise.resolve()
      .then(() => {
        if (appId || appDomain) {
          return this.getAppFromCatalog(appId, appDomain);
        } else {
          return '';
        }
      })
      .then(() => {

        if (customerId) {
          return this.getCustomer(customerId);
        } else {
          return '';
        }
      })
      .then(response => {
        window.location = 'subscriptionorder';
      })
      .catch(err => {
        return ( <Redirect to='/subscriptionorder' /> );
      });
    }
  
    return (
      <div>
        <LoadingSpinner/>
      </div>
    );
  }
}

export default SubscriptionOrderLoad;